import { useApi } from '@/composables/useApi'

const api = useApi()

export default {
  namespaced: true,
  state: {
    currentIntegration: {
      chatSelected: '',
      formPipedriveConfig: [
        { title: 'Nome do contato', id: 'name', value: '' },
        { title: 'Email do contato', id: 'email', value: '' },
        { title: 'Telefone do contato', id: 'phone', value: '' },
      ],
      inteSelected: {
        id: null,
        usuario_condicional_status: 0,
      },
      usuario_condicional: [],
    },
    allTabsComponent: {
      rdstation: 'TabIntegrationRdStation',
      integrations: 'Integration',
      pipedriver: 'TabIntegrationPipeDrive',
      designChat: 'DesignChat',
      chat: 'Chat',
      activecampaign: 'TabIntegrationActiveCampaign',
    },
    tabs: [
      {
        title: 'Gerenciar Fluxos',
        icon: 'MessageSquareIcon',
        component: 'Chat',
        active: true,
      },
    ],
    rdStationIntegration: [],
  },
  getters: {
    getRdStationIntegration(state) {
      return state.rdStationIntegration
    },
    GET_CURRENT_TAB_ACTIVE(state) {
      return state.tabs.find(t => t.active === true)
    },
    GET_CURRENT_INTEGRATION(state) {
      return state.currentIntegration
    },
  },
  mutations: {
    SET_STATUS_INTEGRATION(state, payload) {
      state.rdStationIntegration.forEach(i => {
        if (i.id === payload.id) {
          i.status = payload.status
        }
      })
    },
    RESET_INTEGRATION(state, payload) {
      state.currentIntegration = payload
    },
    SET_CURRENT_INTEGRATION_ACTIVE(state, payload) {
      console.log('SET_CURRENT_INTEGRATION_ACTIVE', payload)
      state.currentIntegration = {
        inteSelected: payload,
        chatSelected: payload.id_chat,
        formActivicampaignConfig: JSON.parse(payload.modelo_metadata),
      }
    },
    SET_CURRENT_INTEGRATION(state, payload) {
      console.log('SET_CURRENT_INTEGRATION', payload)
      state.currentIntegration = {
        inteSelected: payload,
        usuario_condicional: JSON.parse(payload.usuario_condicional),
        chatSelected: payload.id_chat,
        formPipedriveConfig: JSON.parse(payload.modelo_metadata),
      }
    },
    ADD_RDSTATION_INTEGRATION(state, payload) {
      state.rdStationIntegration.push(payload)
    },
    SET_RDSTATION_INTEGRATION(state, payload) {
      payload.map(p => {
        p.status = p.status === 1
      })
      state.rdStationIntegration = payload
    },
    SET_TABS(state, payload) {
      state.tabs = payload
    },
    RESET_TABS(state, payload) {
      state.tabs = [
        {
          title: 'Gerenciar Fluxos',
          icon: 'MessageSquareIcon',
          component: 'Chat',
          active: false,
        },
      ]
      state.tabs.map(t => {
        if (t.title === payload.title) {
          t.active = true
          t.component = payload.component
        }
      })
    },
    async SET_CURRENT_TAB(state, payload) {
      state.tabs.map(t => {
        if (t.title === payload.title) {
          t.active = true
          t.component = state.allTabsComponent[payload.component]
        } else {
          t.active = false
        }
      })
    },
    async SET_CURRENT_TAB_INTEGRATION(state, payload) {
      state.tabs.map(t => {
        if (t.title === 'Integrações') {
          if (payload === 'FINISH') {
            t.component = state.allTabsComponent.integrations
          } else {
            t.component = state.allTabsComponent[payload]
            t.active = true
          }
        } else {
          t.active = false
        }
      })
    },
    SET_CHAT_SELECTED(state, payload) {
      console.log(`SET_CHAT_SELECTED ${payload}`)
      state.currentIntegration.chatSelected = payload
    },
  },
  actions: {

    async SAVE_INTEGRATION_DB({ commit }, payload) {
      console.log(payload)
      await api.post('/Integracoes', payload)
        .then(response => {
          commit('SET_CURRENT_TAB_INTEGRATION', 'FINISH')
        })
    },
    async GET_INTEGRATION_DB({ commit, rootState }) {
      await api.get(`/Integracoes?id_user=${rootState.User.user.id}`)
        .then(response => {
          commit('SET_RDSTATION_INTEGRATION', response.data)
        })
    },
    async GET_ACCESS_TOKEN_RDSTATION({ commit, rootState }) {
      await api.get(`/getAccessToken?id_user=${rootState.User.user.id}&code=${rootState.AppChatboosterIntegration.rdStation.code}`)
    },
    async GET_ACCESS_TOKEN_PIPEDRIVE({ commit, rootState }) {
      await api.post(`/getTokenPipedrive?id_user=${rootState.User.user.id}&code=${rootState.AppChatboosterIntegration.pipeDrive.code}`)
    },
    async GET_CHAT_BY_ID({ commit }, payload) {
      console.log(`GET_CHAT_BY_ID ${payload.id_chat}`)
      await api.get(`/getChatInnerDesign/${payload.id_chat}`)
        .then(response => {
          console.log('GET_CHAT_BY_ID', response.data)
          commit('SET_CHAT_SELECTED', response.data[0])
        })
    },
  },
}
